import React from "react";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import {
    createPaymentCostCenter,
    renameCostCenter,
} from "../../../../api/financial";

export default (props) => {
    const ref = React.useRef();
    const [id, setId] = React.useState("");
    const [name, setName] = React.useState("");
    const [loading, setLoading] = React.useState(false);

    function onSave() {
        if (loading) {
            return;
        }
        setLoading(true);
        const request = (id, name) => {
            return props.edit ? renameCostCenter(id, name) : createPaymentCostCenter(name)
        } 
        request(id, name)
            .then((resp) => {
                setTimeout(() => {
                    if (props.onSave) {
                        props.onSave(resp)
                    }
                    setLoading(false);
                    setName("");
                    setId("")
                    if(props.onHide){
                        props.onHide()
                    }
                }, 400);

            })
            .catch((error) => { });
    }

    React.useEffect(() => {
        if(props.show && props.edit) {
            setName(props.edit.name)
            setId(props.edit.id)
        }
    }, [props.show])

    return (
        <Modal
            title="Centro de Custo"
            show={props.show}
            onHide={() => {
                setName("")
                setId("")
                if(props.onHide){
                    props.onHide()
                }
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-xs-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text color="primary">Nome do Centro de Custo</Text>
                            </div>
                            <LoadingInput
                                name="name"
                                loading={loading}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <Button disabled={loading || name.length < 2} onClick={onSave}>
                            {props.edit? "Editar":"Cadastrar"}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/PaymentCostCenter/createEditModal.jsx